/**
 * Fabriques d'URL — un seul endroit où la forme des routes est décidée.
 */

/** `/acteur/Brad%20Pitt` — le nom reste lisible et l'URL partageable. */
export const actorPath = (name) => `/acteur/${encodeURIComponent((name || '').trim())}`;

/** Lecture du paramètre de route inverse. */
export const actorNameFromParam = (param) => {
  try {
    return decodeURIComponent(param || '').trim();
  } catch {
    return (param || '').trim();
  }
};

export const explorePath = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '' && value !== 'all') {
      search.set(key, Array.isArray(value) ? value.join(',') : String(value));
    }
  });
  const query = search.toString();
  return query ? `/explorer?${query}` : '/explorer';
};

export const titlePath = (title) =>
  title?.isGroupedSeries || title?.type === 'serie'
    ? `/serie/${title.tmdbId}`
    : `/film/${title?.id}`;
